import {
  faArrowUpRightFromSquare,
  faSpinner
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useState } from 'react'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import Error from '../../Utilities/Error'

import { Link } from 'react-router-dom'
import { PRODUCT_MAP } from '../../../constants/products'
import { AuthenticationContext } from '../../../context/authenticationContext'
import { PRODUCT_NAME } from '../../../utils/ENV'
import LoginCommandCenter from '../LoginCommandCenter'

const EmailForm = ({ turnstile }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState({
    state: false,
    data: {}
  })
  const { signUp } = useContext(AuthenticationContext)
  const { productsService, [SETTINGS.PHONE_NUMBERS.key]: phoneNumbers } =
    useContext(SiteConfigContext)
  const [email, setEmail] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError({
      state: false,
      data: {}
    })

    const response = await signUp({
      email,
      signUpList: {
        listCodes: productsService[PRODUCT_MAP.THIS_PRODUCT].access.listCodes,
        sourceId: productsService[PRODUCT_MAP.THIS_PRODUCT].access.sourceId,
        emailOversightId:
          productsService[PRODUCT_MAP.THIS_PRODUCT].access.emailOversightId
      },
      freeListSignUp: true
    })

    if (!response || response.success === false) {
      setError({
        state: true,
        data: response.data
      })
    }
    setLoading(false)
  }

  const handleReset = () => {
    setError({
      state: false,
      data: {}
    })
  }

  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      {error.state && (
        <>
          <Error
            message={error.data.message}
            extras={error.data.extras}
            phoneNumbers={phoneNumbers}
          />
          {error?.data?.extras?.hideSignUp && <LoginCommandCenter />}
        </>
      )}
      {error?.data?.extras?.hideSignUp ? (
        <div className="link cursor-pointer" onClick={handleReset}>
          <strong className="text-sm">Try again?</strong>
        </div>
      ) : (
        <div className={!turnstile ? 'p-2' : ''}>
          <div>
            <p className="text-xs leading-snug mb-2">
              By submitting your email address, you will receive a free
              subscription to <em>{PRODUCT_NAME}</em>, and offers from us and
              our affiliates that we think might interest you. You can
              unsubscribe at any time.{' '}
              <Link to="/privacy-policy" target="_blank" className="link">
                <strong>
                  Privacy Policy
                  <FontAwesomeIcon
                    icon={faArrowUpRightFromSquare}
                    className="ml-1 w-3 h-3"
                  />
                </strong>
              </Link>
            </p>
          </div>
          <div className="flex gap-2">
            <input
              className="input w-full"
              name="email"
              type="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            {loading ? (
              <span className="flex items-center justify-center">
                <span className="sr-only">Validating...</span>
                <FontAwesomeIcon
                  icon={faSpinner}
                  className="animate-spin h-4 text-neutral-500"
                />
              </span>
            ) : (
              <button
                type="submit"
                className="button-confirm whitespace-nowrap w-fit"
                disabled={loading}
                required
              >
                Sign Up
              </button>
            )}
          </div>
          <div>
            <p className="text-xs mt-2">
              <Link
                to="/do-not-sell"
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                <strong>
                  Do Not Sell or Share My Personal Information
                  <FontAwesomeIcon
                    icon={faArrowUpRightFromSquare}
                    className="ml-1 w-3 h-3"
                  />
                </strong>
              </Link>
            </p>
          </div>
        </div>
      )}
    </form>
  )
}

export default EmailForm
